import { FolderOpen, Sparkles, Zap } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { t } from "@/lib/localization";

const featuresList = [
    {
        icon: Sparkles,
        titleKey: "payments.payment-wall.features.ai.title",
        descriptionKey: "payments.payment-wall.features.ai.description",
    },
    {
        icon: FolderOpen,
        titleKey: "payments.payment-wall.features.storage.title",
        descriptionKey: "payments.payment-wall.features.storage.description",
    },
    {
        icon: Zap,
        titleKey: "payments.payment-wall.features.interactions.title",
        descriptionKey:
            "payments.payment-wall.features.interactions.description",
    },
];

export default function PaymentWall() {
    return (
        <div className="flex-1 flex flex-col w-full justify-center px-4 py-4">
            <h2 className="text-3xl tracking-tight font-bold">
                {t("payments.payment-wall.title")}
            </h2>
            <p className="mt-2 text-base text-gray-700">
                {t("payments.payment-wall.description")}
            </p>
            <div className="mt-4 flex flex-col gap-4">
                {featuresList.map((feature, idx) => (
                    <div key={idx} className="flex flex-row items-center gap-2">
                        <feature.icon className="size-5 text-primary flex-shrink-0" />
                        <p>
                            <b>{t(feature.titleKey)}</b> -{" "}
                            {t(feature.descriptionKey)}
                        </p>
                    </div>
                ))}
            </div>
            <a
                href="/settings/pricing"
                className={cn(buttonVariants({ variant: "ai" }), "mt-6 w-full")}
            >
                {t("payments.payment-wall.cta")}
            </a>
            {/* <p className="mt-2 text-sm text-muted-foreground text-center">
                {t("payments.payment-wall.cancel-note")}
            </p> */}
        </div>
    );
}
